import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init, getLLEInvoice } from './modules'
import Loading from 'components/Loading'

export default function(route) {
  const Detail = Loadable({
    loader: () => import('./Detail'),
    render(loaded, props) {
      const Component = connect(
        (state) => ({
          transactionDetailState: state.transactionDetailState,
          siteConfig: state.siteConfig,
        }),
        {
          init,
          getLLEInvoice,
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/detail`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Detail {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
